var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',{staticClass:"py-4",attrs:{"id":"embeDDed-card","elevation":"0"}},[_c('iframe',{staticClass:"frame-pdf",attrs:{"width":"100%","height":"100%","src":_vm.portalData.menu}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }